type SaveButtonState = {
    saveValue: Record<string, any>;
    saveMeta: Record<string, any>;
}

function getSaveSearchState( type: string ): SaveButtonState | null {
    const saveSearchButton = document.querySelector<HTMLButtonElement>( `[data-save-property=${type}]` );

    if ( !saveSearchButton ) {
        return null;
    }

    const state: SaveButtonState = {
        saveValue: {},
        saveMeta: {},
    };

    const data = saveSearchButton.dataset;

    if ( data.saveValue ) {
        state.saveValue = JSON.parse( data.saveValue );
    }

    if ( data.saveMeta ) {
        state.saveMeta = JSON.parse( data.saveMeta );
    }

    return state;
}

export {
    getSaveSearchState,
};
